import { FraudTracking } from './FraudTracking';

export default FraudTracking;
